export default "__VITE_ASSET__16xn4cWQ__"